import { css } from 'react-emotion'

const styles = {
  header: css({
    color: '#888 !important',
    marginTop: '15px !important',
    marginBottom: '25px !important'
  }),
  signupForm: css({
  }),
  divider: css({
    color: '#ccc !important'
  })
}

export default styles



// WEBPACK FOOTER //
// ./src/Pages/Auth/SignupStyles.js